import * as React from 'react';
import { memo } from 'react';

const SvgHomeV2 = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.71 15.188h3.646v-6.12h5v6.12h3.646v-9.22l-6.146-4.66-6.147 4.66v9.22Zm0 1.146c-.313 0-.582-.113-.807-.339a1.102 1.102 0 0 1-.339-.807v-9.22c0-.173.04-.342.117-.507a.986.986 0 0 1 .352-.404L7.178.423c.087-.07.191-.126.313-.17a1.082 1.082 0 0 1 1.042.17l6.145 4.635a.985.985 0 0 1 .353.404c.077.165.116.334.116.508v9.218c0 .313-.113.582-.339.808a1.098 1.098 0 0 1-.806.339H9.209v-6.12H6.502v6.12H1.709Z", fill: "currentColor" })));
const Memo = memo(SvgHomeV2);

export { Memo as default };
